// extracted by mini-css-extract-plugin
export default {"container":"AboutUs_container__TjXRN","highlight":"AboutUs_highlight__QK2EJ"};